<template>
  <component
    :is="claimShowComponent"
    v-if="projectsStore.project"
    :project-id="projectId"
    :claim-id="claimId"
    :package-id="packageId"
  />
</template>

<script setup lang="ts">
import { useProjectsStore } from '@/store/projects';
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import SubcontractorClaimShow from './SubcontractorClaimShow.vue';
import SubcontractorClaimShowLite from './SubcontractorClaimShowLite.vue';

const props = defineProps<{
  projectId: string;
  claimId: string;
  packageId: string;
}>();

const projectsStore = useProjectsStore();
const router = useRouter();

watch(() => props.projectId, (newValue, oldValue) => {
  if(newValue !== oldValue) {
    router.push({ name: 'SubcontractorClaimsDashboard' });
  }
});

const claimShowComponent = computed(() => {
  return projectsStore.project?.feature_flag_subcontractor_claims_lite ?
    SubcontractorClaimShowLite :
    SubcontractorClaimShow;
});
</script>
